import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getPostList = createAsyncThunk(
  "posts/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.posts +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
    return response.data;
  }
);


export const addPost = createAsyncThunk(
  "post/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.posts, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editPost = createAsyncThunk(
  "post/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.posts + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getPostCount = async () =>{
  const response = await Client(API_METHOD.GET, url.posts)
  return response.data?.data?.item?.total_count;
}

export const getPost = createAsyncThunk("post/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.posts + `/${id}`);
  return response.data;
});

